import React from 'react'

function TechSelectionVAPV() {
  return (
    <embed src="\pdfs\E1.5.5_VA-PV_Radial_displacement_outlet_03.2013_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionVAPV